import { IBookingScheduler } from '../../models'

export enum BookingSchedulerTypeKeys {
  FETCH_BOOKING_SCHEDULERS = 'FETCH_BOOKING_SCHEDULERS',
  FETCHING_BOOKING_SCHEDULERS = 'FETCHING_BOOKING_SCHEDULERS',
  FETCH_BOOKING_SCHEDULERS_SUCCESSFUL = 'FETCH_BOOKING_SCHEDULERS_SUCCESSFUL',
  ADD_BOOKING_SCHEDULER = 'ADD_BOOKING_SCHEDULER',
  ADDING_BOOKING_SCHEDULER = 'ADDING_BOOKING_SCHEDULER',
  ADD_BOOKING_SCHEDULER_SUCCESSFUL = 'ADD_BOOKING_SCHEDULER_SUCCESSFUL',
  EDIT_BOOKING_SCHEDULER = 'EDIT_BOOKING_SCHEDULER',
  EDITING_BOOKING_SCHEDULER = 'EDITING_BOOKING_SCHEDULER',
  EDIT_BOOKING_SCHEDULER_SUCCESSFUL = 'EDIT_BOOKING_SCHEDULER_SUCCESSFUL',
  SET_SELECTED_BOOKING_SCHEDULER_MODAL = 'SET_SELECTED_BOOKING_SCHEDULER_MODAL',
  REMOVE_BOOKING_SCHEDULER = 'REMOVE_BOOKING_SCHEDULER',
  REMOVING_BOOKING_SCHEDULER = 'REMOVING_BOOKING_SCHEDULER',
  REMOVE_BOOKING_SCHEDULER_SUCCESSFUL = 'REMOVE_BOOKING_SCHEDULER_SUCCESSFUL'
}

export interface IFetchBookingSchedulersAction {
  type: typeof BookingSchedulerTypeKeys.FETCH_BOOKING_SCHEDULERS
  [extraProps: string]: unknown
}

export interface ISetIsFetchingBookingSchedulersAction {
  type: typeof BookingSchedulerTypeKeys.FETCHING_BOOKING_SCHEDULERS
  [extraProps: string]: unknown
}

export interface IFetchBookingSchedulersSuccessfulAction {
  type: typeof BookingSchedulerTypeKeys.FETCH_BOOKING_SCHEDULERS_SUCCESSFUL
  payload: IBookingScheduler[]
  [extraProps: string]: unknown
}

export interface IAddBookingSchedulerAction {
  type: typeof BookingSchedulerTypeKeys.ADD_BOOKING_SCHEDULER
  payload: IBookingScheduler
  [extraProps: string]: unknown
}

export interface IAddingBookingSchedulerAction {
  type: typeof BookingSchedulerTypeKeys.ADDING_BOOKING_SCHEDULER
  [extraProps: string]: unknown
}

export interface IAddBookingSchedulerSuccessfulAction {
  type: typeof BookingSchedulerTypeKeys.ADD_BOOKING_SCHEDULER_SUCCESSFUL
  [extraProps: string]: unknown
}

export interface IEditBookingSchedulerAction {
  type: typeof BookingSchedulerTypeKeys.EDIT_BOOKING_SCHEDULER
  payload: IBookingScheduler
  [extraProps: string]: unknown
}

export interface IEditingBookingSchedulerAction {
  type: typeof BookingSchedulerTypeKeys.EDITING_BOOKING_SCHEDULER
  [extraProps: string]: unknown
}

export interface IEditBookingSchedulerSuccessfulAction {
  type: typeof BookingSchedulerTypeKeys.EDIT_BOOKING_SCHEDULER_SUCCESSFUL
  [extraProps: string]: unknown
}

export interface ISetSelectedBookingSchedulerModalAction {
  type: typeof BookingSchedulerTypeKeys.SET_SELECTED_BOOKING_SCHEDULER_MODAL
  payload: IBookingScheduler | null
  [extraProps: string]: unknown
}

export interface IRemoveBookingSchedulerAction {
  type: typeof BookingSchedulerTypeKeys.REMOVE_BOOKING_SCHEDULER
  [extraProps: string]: unknown
}

export interface IRemovingBookingSchedulerAction {
  type: typeof BookingSchedulerTypeKeys.REMOVING_BOOKING_SCHEDULER
  [extraProps: string]: unknown
}

export interface IRemoveBookingSchedulerSuccessfulAction {
  type: typeof BookingSchedulerTypeKeys.REMOVE_BOOKING_SCHEDULER_SUCCESSFUL
  [extraProps: string]: unknown
}

export type BookingSchedulerActionTypes =
  | IFetchBookingSchedulersAction
  | ISetIsFetchingBookingSchedulersAction
  | IFetchBookingSchedulersSuccessfulAction
  | IAddBookingSchedulerAction
  | IAddingBookingSchedulerAction
  | IAddBookingSchedulerSuccessfulAction
  | IEditBookingSchedulerAction
  | IEditingBookingSchedulerAction
  | IEditBookingSchedulerSuccessfulAction
  | ISetSelectedBookingSchedulerModalAction
  | IRemoveBookingSchedulerAction
  | IRemovingBookingSchedulerAction
  | IRemoveBookingSchedulerSuccessfulAction
